var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comm_back_cla" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass: "button_cla",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.goBack($event)
            }
          }
        },
        [_vm._v("返回上一级")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "button_cla",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.goDashbord($event)
            }
          }
        },
        [_vm._v("首页")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13bd193b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13bd193b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/error/src/main.vue
// module id = null
// module chunks = 